import {
  UiButtonColorType,
  UiButtonExpandType,
  UiButtonRoundType,
  UiButtonSizeType,
} from './types';

export const uiButtonClassNames = {
  get root(): string {
    return 'ui-button';
  },

  size(size: UiButtonSizeType): string {
    return `${this.root}--size-${size}`;
  },

  color(color: UiButtonColorType): string {
    return `${this.root}--color-${color}`;
  },

  round(round: UiButtonRoundType): string {
    return `${this.root}--round-${round}`;
  },

  expand(expand: UiButtonExpandType): string {
    return `${this.root}--expand-${expand}`;
  },
};
